"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressProviderFromJson = void 0;
class AddressProviderFromJson {
    constructor(data) {
        this.data = data;
    }
    bLunaHub() {
        return this.data.bLunaHub;
    }
    bLunaValidatorsRegistry() {
        return this.data.bLunaValidatorsRegistry;
    }
    bLunaToken() {
        return this.data.bLunaToken;
    }
    market() {
        return this.data.mmMarket;
    }
    overseer() {
        return this.data.mmOverseer;
    }
    aTerra() {
        return this.data.aTerra;
    }
    oracle() {
        return this.data.mmOracle;
    }
    interest() {
        return this.data.mmInterestModel;
    }
    distribution() {
        return this.data.mmDistributionModel;
    }
    liquidation() {
        return this.data.mmLiquidation;
    }
    liquidationQueue() {
        return this.data.mmLiquidationQueue;
    }
    bLunaLunaPair() {
        return this.data.bLunaLunaPair;
    }
    bLunaLunaLPToken() {
        return this.data.bLunaLunaLPToken;
    }
    gov() {
        return this.data.gov;
    }
    ancUstPair() {
        return this.data.ancUstPair;
    }
    ancUstLPToken() {
        return this.data.ancUstLPToken;
    }
    collector() {
        return this.data.collector;
    }
    staking() {
        return this.data.staking;
    }
    community() {
        return this.data.community;
    }
    distributor() {
        return this.data.distributor;
    }
    ANC() {
        return this.data.ANC;
    }
    airdrop() {
        return this.data.airdrop;
    }
    investorLock() {
        return this.data.investor_vesting;
    }
    teamLock() {
        return this.data.team_vesting;
    }
}
exports.AddressProviderFromJson = AddressProviderFromJson;
//# sourceMappingURL=from-json.js.map